module.exports = __webpack_public_path__ + "img/solution-lightXML-system-pic.92e28695.png";